var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Modal from 'react-bootstrap/Modal';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
function ModalSaveArtInformation(_a) {
    var show = _a.show, closeModal = _a.closeModal, onConfirm = _a.onConfirm;
    return (_jsxs(Modal, __assign({}, { show: show, onHide: closeModal }, { "aria-labelledby": "contained-modal-title-vcenter", centered: true, className: "default-modal-styling modal-art-generator" }, { children: [_jsxs(Modal.Header, { children: [_jsx(Modal.Title, { children: "Salvar informa\u00E7\u00F5es?" }), _jsx(IconButton, __assign({ onClick: closeModal, "aria-label": "Fechar", size: "small", sx: { padding: 0 } }, { children: _jsx(CloseIcon, {}) }))] }), _jsx(Modal.Body, { children: "Deseja salvar essas informa\u00E7\u00F5es para usar no futuro, sem precisar preencher tudo novamente?" }), _jsxs(Modal.Footer, { children: [_jsx("button", __assign({ type: "button", onClick: closeModal, className: "button-with-blue-border", style: { width: "106px", height: "36px" } }, { children: "N\u00E3o salvar" })), _jsx("button", __assign({ type: "button", onClick: onConfirm, className: "blue-button", style: { width: "106px", height: "36px" } }, { children: "Salvar" }))] })] })));
}
export default ModalSaveArtInformation;
